<div class="d-flex more-actions" aria-label="Actions">
    <button 
        type="button" 
        class="icon icon-btn fill-iconDefault" 
        [popover]="popoverTemplate"
        triggers="click"
        #actionPopover="bs-popover"
        containerClass="cxone-popover"
        container=".cx-one-ui"
        [outsideClick]="true"
        [placement]="placement" 
        *ngIf="showViewBtn">
            <svg class="icon-16">
                <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
            </svg>
            <ng-template #popoverTemplate>
                <div class="more-option-popover">
                    <ul>
                        <li class="clickable" (click)="onAction('edit')" id="edit-action-btn"
                            *ngIf="showEditBtn && (dataFeed.IsEditable || canEditLocked)">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                            </svg>
                            <span class="more-option-text" cvLocalizedText
                            langSection="ETL_Data_Feed" langKey="Edit">Edit</span>
                        </li>
                        <li class="clickable" (click)="onAction('preview')" id="preview-action-btn" *ngIf="showPreviewBtn || (!dataFeed.IsEditable && !canEditLocked)">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/preview.svg#preview"></use>
                            </svg>
                            <span class="more-option-text" cvLocalizedText langSection="ETL_Data_Feed" langKey="Preview">Preview</span>
                        </li>
                        <li class="clickable" id="view-action-btn" (click)="onAction('view')"
                            [ngClass]="{ 'option-disabled': !dataFeed.Status.LastSuccessDate || dataFeed.SourceSystem === 'Unrecognized' }" *ngIf="showViewBtn">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/file-read.svg#file-read"></use>
                            </svg>
                            <span class="more-option-text" cvLocalizedText
                            langSection="ETL_Data_Feed" langKey="View_Records">View Records</span>
                        </li>
                        <li class="clickable" id="reactivate-action-btn"
                        [ngClass]="{ 'option-disabled': dataFeed.Status.IsValid || dataFeed.SourceSystem === 'Unrecognized' }"
                        (click)="onAction('reactivate')" *ngIf="showReactivateBtn">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/cxone-reactivate.svg#cxone-reactivate"></use>
                            </svg>
                            <span class="more-option-text" cvLocalizedText
                            langSection="ETL_Data_Feed" langKey="Reactivate">Reactivate</span>
                        </li>
                        <li class="clickable" id="delete-action-btn" [ngbPopover]="deleteDataFeedPopover" triggers="manual"
                            container=".cx-one-ui" placement="left"
                            #popoverRef="ngbPopover" (click)="onAction('delete', popoverRef)"
                            [ngClass]="{ 'option-disabled': dataFeed.SourceSystem === 'Unrecognized' }" *ngIf="showDeleteBtn && (dataFeed.IsEditable || canEditLocked)">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                            </svg>
                            <span class="more-option-text" cvLocalizedText
                            langSection="ETL_Data_Feed" langKey="Delete">Delete</span>
                        </li>
                    </ul>
                </div>
            </ng-template>
    </button>
    <!-- template for delete module ngbPopover-->
    <ng-template #deleteDataFeedPopover>
        <div class="delete-popover-wrapper">
            <div class="delete-popover">
                <div class="inner" cvLocalizedText langSection="ETL_Data_Feed" langKey="Delete_Data_Feed_Popover">Are you sure you want to delete this data feed?</div>
            </div>

            <div class="confirm-btns">
                <button class="cxone-btn btn-secondary btn-medium edit" type="button"
                    (click)="closePopover()"
                    cvLocalizedText [langSection]="'ETL_Data_Feed'" [langKey]="'No'">No</button>
                <button class="cxone-btn btn-medium btn-primary" type="button"
                    (click)="deleteDataFeed()"
                    cvLocalizedText [langSection]="'ETL_Data_Feed'" [langKey]="'Yes'">Yes</button>
            </div>
        </div>
    </ng-template>
</div>
